// source: pbtypes/gen/scan_planner/exploration_orbit_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
goog.exportSymbol('proto.scan_planner.ExplorationOrbitRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.ExplorationOrbitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.ExplorationOrbitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.ExplorationOrbitRequest.displayName = 'proto.scan_planner.ExplorationOrbitRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.ExplorationOrbitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.ExplorationOrbitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ExplorationOrbitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
radius: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
globalMapTCenter: (f = msg.getGlobalMapTCenter()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
radiusVector: (f = msg.getRadiusVector()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
minGimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
maxGimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
numSweeps: jspb.Message.getFieldWithDefault(msg, 6, 0),
numMeasurementsPerSweep: jspb.Message.getFieldWithDefault(msg, 7, 0),
numOptimizations: jspb.Message.getFieldWithDefault(msg, 8, 0),
numIntermediateWaypoints: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.ExplorationOrbitRequest}
 */
proto.scan_planner.ExplorationOrbitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.ExplorationOrbitRequest;
  return proto.scan_planner.ExplorationOrbitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.ExplorationOrbitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.ExplorationOrbitRequest}
 */
proto.scan_planner.ExplorationOrbitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRadius(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setGlobalMapTCenter(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setRadiusVector(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinGimbalPitch(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxGimbalPitch(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumSweeps(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumMeasurementsPerSweep(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumOptimizations(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumIntermediateWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.ExplorationOrbitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.ExplorationOrbitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ExplorationOrbitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRadius();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getGlobalMapTCenter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getRadiusVector();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getMinGimbalPitch();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxGimbalPitch();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getNumSweeps();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getNumMeasurementsPerSweep();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getNumOptimizations();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getNumIntermediateWaypoints();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
};


/**
 * optional double radius = 1;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector3dPb global_map_t_center = 2;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getGlobalMapTCenter = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
*/
proto.scan_planner.ExplorationOrbitRequest.prototype.setGlobalMapTCenter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.clearGlobalMapTCenter = function() {
  return this.setGlobalMapTCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.hasGlobalMapTCenter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional eigen_lcm.Vector2dPb radius_vector = 3;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getRadiusVector = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
*/
proto.scan_planner.ExplorationOrbitRequest.prototype.setRadiusVector = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.clearRadiusVector = function() {
  return this.setRadiusVector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.hasRadiusVector = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double min_gimbal_pitch = 4;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getMinGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setMinGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_gimbal_pitch = 5;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getMaxGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setMaxGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional uint32 num_sweeps = 6;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getNumSweeps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setNumSweeps = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 num_measurements_per_sweep = 7;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getNumMeasurementsPerSweep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setNumMeasurementsPerSweep = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 num_optimizations = 8;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getNumOptimizations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setNumOptimizations = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 num_intermediate_waypoints = 9;
 * @return {number}
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.getNumIntermediateWaypoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExplorationOrbitRequest} returns this
 */
proto.scan_planner.ExplorationOrbitRequest.prototype.setNumIntermediateWaypoints = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


goog.object.extend(exports, proto.scan_planner);
